import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface StatusOption {
  value: number;
  label: string;
}

@Component({
  selector: 'app-active-status-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  template: `
    <mat-form-field appearance="outline" class="field-style">
      <mat-select
        [formControl]="statusControl"
        placeholder="select status"
        (selectionChange)="onStatusChange($event)">
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  styles: [`
    .field-style {
      width: 100%;
    }

    ::ng-deep {
      .mat-mdc-dialog-surface {
        border-radius: 15px !important;
        background-color: #fafafa !important;
      }
        .mat-mdc-form-field {
    height: 48px !important;
    width: 210px !important;
    background-color: white;
    border-radius: 10px !important;
  }
      // .mat-mdc-dialog-container-with-actions .mat-mdc-dialog-content {
      //   overflow: hidden !important;
      //   padding: unset !important;
      // }
      .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled)
        .mat-mdc-text-field-wrapper {
        height: 45px !important;
      }
      .mdc-text-field--disabled {
        height: 45px !important;
      }
      .mat-mdc-form-field-subscript-wrapper{
        display: none !important;
      }
    }
  `]
})
export class ActiveStatusDropdownComponent {
  // @Input() placeholder: string = 'Select Status';
  @Input() value: number = 2; // Default to 'All'
  @Output() selectionChange = new EventEmitter<number>();

  statusControl = new FormControl();

  statusOptions: StatusOption[] = [
    { value: 2, label: 'All' },
    { value: 1, label: 'Active' },
    { value: 0, label: 'Inactive' },
  ];

  ngOnInit() {
    this.statusControl.setValue(this.value);
  }

  onStatusChange(event: any) {
    this.selectionChange.emit(event.value);
  }
}